import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ToDoService {
  public addedTaskSubject = new Subject<unknown>();

  openAddTaskModal(target: unknown) {
    this.addedTaskSubject.next(target);
  }
}
